import { render } from "./FullPage.vue?vue&type=template&id=464d5b8f&scoped=true"
import script from "./FullPage.vue?vue&type=script&lang=js"
export * from "./FullPage.vue?vue&type=script&lang=js"

import "./FullPage.vue?vue&type=style&index=0&id=464d5b8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464d5b8f"]])

export default __exports__